import { render, staticRenderFns } from "./index.pc.vue?vue&type=template&id=4b61266a&scoped=true"
import script from "./index.pc.vue?vue&type=script&lang=js"
export * from "./index.pc.vue?vue&type=script&lang=js"
import style0 from "./index.pc.vue?vue&type=style&index=0&id=4b61266a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b61266a",
  null
  
)

export default component.exports